import styles from './Dropdown.module.scss';

type Props = {
  children: string | JSX.Element | JSX.Element[];
};

export const DropDownItem = ({ children }: Props) => {
  return <li className={styles.list_item}>{children}</li>;
};
